(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["able-react"] = factory();
	else
		root["able-react"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 6337:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src_ActionButton)
});

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(8779);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);
// EXTERNAL MODULE: external "@babel/runtime/helpers/objectWithoutProperties"
var objectWithoutProperties_ = __webpack_require__(3838);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties_);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/Icon/Icon.tsx
var Icon = __webpack_require__(287);
// EXTERNAL MODULE: ./src/_partials/ArrowIcon/index.tsx
var ArrowIcon = __webpack_require__(5458);
// EXTERNAL MODULE: ./src/_partials/InteractiveElement/index.tsx
var InteractiveElement = __webpack_require__(8218);
// EXTERNAL MODULE: external "react/jsx-runtime"
var jsx_runtime_ = __webpack_require__(997);
;// CONCATENATED MODULE: ./src/_partials/OpensNewTabSrOnlySpan/index.tsx

/**
 *
 * OpensNewTabSrOnlySpan is a component partial used by ActionButton and ActionListItem
 *
 */

var OpensNewTabSrOnlySpan = function OpensNewTabSrOnlySpan() {
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("span", {
    className: "able-sr-only",
    children: ", opens new tab"
  });
};
/* harmony default export */ const _partials_OpensNewTabSrOnlySpan = (OpensNewTabSrOnlySpan);
// EXTERNAL MODULE: ./src/_helpers/convertKeyValuesIntoDataAttributes.ts
var convertKeyValuesIntoDataAttributes = __webpack_require__(4217);
;// CONCATENATED MODULE: ./src/ActionButton/ActionButton.tsx


var _excluded = ["className", "deleteIcon", "developmentUrl", "icon", "label", "variant", "includeScreenReaderOpenInNewTabText", "includeAbleClassnames", "ref", "elementRef", "opensNewTab", "externalSite", "element", "dataAttributesKeyValuePairs"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







/**
 * Action buttons are used as a cue to perform actions or navigate within a flow,
 * the user can interact by clicking on the button.
 *
 * [View the Action Button pattern documentation on Confluence](https://confluence.tools.telstra.com/display/DCSYS/A1+Action+Button)
 *
 * @version 1.0.0
 */



function ActionButton(props) {
  var className = props.className,
    deleteIcon = props.deleteIcon,
    developmentUrl = props.developmentUrl,
    icon = props.icon,
    label = props.label,
    variant = props.variant,
    includeScreenReaderOpenInNewTabText = props.includeScreenReaderOpenInNewTabText,
    _props$includeAbleCla = props.includeAbleClassnames,
    includeAbleClassnames = _props$includeAbleCla === void 0 ? true : _props$includeAbleCla,
    ref = props.ref,
    elementRef = props.elementRef,
    opensNewTab = props.opensNewTab,
    externalSite = props.externalSite,
    element = props.element,
    dataAttributesKeyValuePairs = props.dataAttributesKeyValuePairs,
    other = objectWithoutProperties_default()(props, _excluded);
  var ableVariants = {
    LowEmphasis: {
      cssName: 'low-emphasis',
      hasArrow: true,
      allowsIcon: true
    },
    LowEmphasisBig: {
      cssName: 'low-emphasis-big',
      hasArrow: true,
      allowsIcon: true
    },
    Destructive: {
      cssName: 'destructive',
      hasArrow: true,
      allowsIcon: false
    },
    MediumEmphasis: {
      cssName: 'medium-emphasis',
      hasArrow: false,
      allowsIcon: false
    },
    HighEmphasis: {
      cssName: 'high-emphasis',
      hasArrow: false,
      allowsIcon: false
    },
    MediumEmphasisCompact: {
      cssName: 'medium-emphasis-compact',
      hasArrow: false,
      allowsIcon: false
    },
    HighEmphasisCompact: {
      cssName: 'high-emphasis-compact',
      hasArrow: false,
      allowsIcon: false
    },
    HighEmphasisDestructive: {
      cssName: 'high-emphasis-destructive',
      hasArrow: false,
      allowsIcon: false
    }
  };
  var classes = includeAbleClassnames ? classnames_default()('able-ActionButton', "able-ActionButton--".concat(ableVariants[variant].cssName), className) : classnames_default()(className);
  var showDeleteIcon = deleteIcon && variant === 'Destructive';
  var CustomIcon = function CustomIcon() {
    if (icon && !showDeleteIcon && ableVariants[variant].allowsIcon) {
      return /*#__PURE__*/(0,jsx_runtime_.jsx)(Icon/* default */.Z, {
        icon: icon,
        developmentUrl: developmentUrl
      });
    }
    if (showDeleteIcon) {
      return /*#__PURE__*/(0,jsx_runtime_.jsx)(Icon/* default */.Z, {
        icon: "Delete",
        developmentUrl: developmentUrl
      });
    }
    return null;
  };
  var filteredOpensNewTab = element.toLowerCase() !== 'button' && (opensNewTab || includeScreenReaderOpenInNewTabText || externalSite);
  var filteredDataAttributes = dataAttributesKeyValuePairs ? (0,convertKeyValuesIntoDataAttributes/* convertKeyValuesIntoDataAttributes */.N)(dataAttributesKeyValuePairs) : '';
  var buttonChildren = function buttonChildren() {
    return /*#__PURE__*/(0,jsx_runtime_.jsxs)(jsx_runtime_.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)(CustomIcon, {}), "".concat(label), filteredOpensNewTab ? /*#__PURE__*/(0,jsx_runtime_.jsx)(_partials_OpensNewTabSrOnlySpan, {}) : null, ableVariants[variant].hasArrow && !icon && variant !== 'Destructive' || variant === 'Destructive' && !showDeleteIcon ? /*#__PURE__*/(0,jsx_runtime_.jsx)(ArrowIcon/* default */.Z, {}) : null]
    });
  };
  return /*#__PURE__*/(0,jsx_runtime_.jsx)(InteractiveElement/* default */.Z, _objectSpread(_objectSpread(_objectSpread({}, other), filteredDataAttributes), {}, {
    element: element,
    className: classes,
    opensNewTab: filteredOpensNewTab,
    elementRef: ref || elementRef,
    children: buttonChildren()
  }));
}
ActionButton.defaultProps = {
  deleteIcon: false,
  developmentUrl: undefined,
  icon: undefined,
  opensNewTab: false
};
/* harmony default export */ const ActionButton_ActionButton = (ActionButton);
// EXTERNAL MODULE: ./src/ActionButton/ActionButton.scss
var src_ActionButton_ActionButton = __webpack_require__(6088);
;// CONCATENATED MODULE: ./src/ActionButton/index.ts


/* harmony default export */ const src_ActionButton = (ActionButton_ActionButton);

/***/ }),

/***/ 287:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8779);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3838);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(997);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__);


var _excluded = ["className", "developmentUrl", "icon", "screenReaderContent", "size"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var iconVersion = 12;

/**
 * Icons are symbols that provide visual context and communicate function
 * or intent in a universal way.
 *
 * Available icon names are listed at https://confluence.tools.telstra.com/display/DCSYS/A1+Icons
 *
 * @version 1.0.0
 */
function Icon(props) {
  var className = props.className,
    developmentUrl = props.developmentUrl,
    icon = props.icon,
    screenReaderContent = props.screenReaderContent,
    size = props.size,
    other = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default()(props, _excluded);
  var href = developmentUrl || "//www.telstra.com.au/content/dam/tcom/able/able-sprites.svg?v".concat(iconVersion);
  var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()('able-icon', "able-icon--".concat(size), className || null);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("svg", _objectSpread(_objectSpread(_objectSpread({
    className: classes,
    role: "img",
    "aria-hidden": !screenReaderContent ? 'true' : 'false'
  }, screenReaderContent && {
    'aria-label': screenReaderContent
  }), {}, {
    focusable: "false"
  }, other), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("use", {
      href: "".concat(href, "#").concat(icon)
    })
  }));
}
Icon.defaultProps = {
  screenReaderContent: null,
  developmentUrl: null,
  className: null,
  size: 24
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Icon);

/***/ }),

/***/ 1257:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(287);
/* harmony import */ var _Icon_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1491);
/* harmony import */ var _Icon_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Icon_scss__WEBPACK_IMPORTED_MODULE_0__);


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);

/***/ }),

/***/ 4217:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   N: () => (/* binding */ convertKeyValuesIntoDataAttributes)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(353);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);

var convertKeyValuesIntoDataAttributes = function convertKeyValuesIntoDataAttributes(attributes) {
  var attributesAsArray = Object.entries(attributes).map(function (_ref) {
    var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return ["data-".concat(key), value];
  });
  return Object.fromEntries(attributesAsArray);
};


/***/ }),

/***/ 5458:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(997);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);


/**
 *
 * ArrowIcon is a component partial used in some interaction patterns.
 *
 * @link https://confluence.tools.telstra.com/display/DCSYS/A1+Action+List
 * @param {string} className custom classname
 * @version 1.0.0
 */

var ArrowIcon = function ArrowIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
    className: className,
    version: "1.1",
    "aria-hidden": "true",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
      d: "M21.28 11.47 16 6.19a.75.75 0 0 0-1.06 0 .75.75 0 0 0 0 1.06L19.69 12l-4.75 4.75A.75.75 0 1 0 16 17.81l5.28-5.28a.75.75 0 0 0 0-1.06Z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
      className: "arr02",
      x: "5.5",
      y: "11.25",
      width: "15",
      height: "1.5",
      rx: ".75"
    })]
  });
};
ArrowIcon.defaultProps = {
  className: ''
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ArrowIcon);

/***/ }),

/***/ 8218:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8779);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3838);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4661);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_router_dom__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(997);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__);


var _excluded = ["children", "className", "element", "elementRef", "events", "externalSite", "opensNewTab", "href", "type", "to", "state", "ariaDisabled"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/**
 * InteractiveElement is a component partial which can render anchors, buttons, React Links & NavLink
 *
 * @link https://confluence.tools.telstra.com/display/DCSYS/A1+Action+List
 * @version 1.0.0
 */

function InteractiveElement(props) {
  var children = props.children,
    className = props.className,
    element = props.element,
    elementRef = props.elementRef,
    events = props.events,
    externalSite = props.externalSite,
    opensNewTab = props.opensNewTab,
    href = props.href,
    type = props.type,
    to = props.to,
    state = props.state,
    ariaDisabled = props.ariaDisabled,
    other = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default()(props, _excluded);
  var filteredOpensNewTab = opensNewTab || externalSite;
  if (!filteredOpensNewTab) {
    if (events) {
      if (events.rel) {
        delete events.rel;
      }
      if (events.target && events.target === '_blank') {
        delete events.target;
      }
    }
  }
  var filteredTarget = element && element !== 'button' && filteredOpensNewTab ? '_blank' : undefined;
  var elementProps = _objectSpread(_objectSpread(_objectSpread({}, events), other), {}, {
    className: className,
    ref: elementRef,
    'aria-disabled': ariaDisabled,
    target: filteredTarget,
    rel: filteredOpensNewTab ? 'noopener noreferrer' : undefined
  });
  var targetURL = href || to || '/';
  if (element === 'a') {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", _objectSpread(_objectSpread({
      href: targetURL
    }, elementProps), {}, {
      children: children
    }));
  }
  if (element === 'Link') {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_router_dom__WEBPACK_IMPORTED_MODULE_2__.Link, _objectSpread(_objectSpread({
      to: targetURL
    }, elementProps), {}, {
      state: state,
      children: children
    }));
  }
  if (element === 'NavLink') {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_router_dom__WEBPACK_IMPORTED_MODULE_2__.NavLink, _objectSpread(_objectSpread({
      to: targetURL
    }, elementProps), {}, {
      children: children
    }));
  }
  return (
    /*#__PURE__*/
    // https://github.com/yannickcr/eslint-plugin-react/issues/1555
    // eslint-disable-next-line react/button-has-type
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("button", _objectSpread(_objectSpread({
      type: type
    }, elementProps), {}, {
      children: children
    }))
  );
}
InteractiveElement.defaultProps = {
  className: undefined,
  elementRef: undefined,
  events: undefined,
  externalSite: false,
  opensNewTab: false,
  href: undefined,
  to: undefined,
  type: 'button',
  id: undefined
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InteractiveElement);

/***/ }),

/***/ 4184:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 6088:
/***/ (() => {



/***/ }),

/***/ 1491:
/***/ (() => {



/***/ }),

/***/ 4875:
/***/ (() => {



/***/ }),

/***/ 8779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 3838:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/objectWithoutProperties");

/***/ }),

/***/ 353:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/slicedToArray");

/***/ }),

/***/ 4661:
/***/ ((module) => {

"use strict";
module.exports = require("react-router-dom");

/***/ }),

/***/ 997:
/***/ ((module) => {

"use strict";
module.exports = require("react/jsx-runtime");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src_MessageSection)
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/Icon/index.ts
var Icon = __webpack_require__(1257);
// EXTERNAL MODULE: ./src/ActionButton/index.ts + 2 modules
var ActionButton = __webpack_require__(6337);
// EXTERNAL MODULE: external "react/jsx-runtime"
var jsx_runtime_ = __webpack_require__(997);
;// CONCATENATED MODULE: ./src/MessageSection/MessageSection.tsx





/**
 * Message Sections are used to notify users of important information or changes on a page or section of a page in a way that attracts the user’s attention without interrupting their task.
 * They typically appear at the top of a page or section on page load. They are not inserted dynamically.
 * [View the Message Section pattern documentation on Confluence](https://confluence.tools.telstra.com/display/DCSYS/A1+Message+Section)
 *
 * @version 1.0.0
 */
function MessageSection(props) {
  var className = props.className,
    description = props.description,
    _props$developmentUrl = props.developmentUrl,
    developmentUrl = _props$developmentUrl === void 0 ? '' : _props$developmentUrl,
    variant = props.variant,
    actionText = props.actionText,
    _props$actionElement = props.actionElement,
    actionElement = _props$actionElement === void 0 ? 'a' : _props$actionElement,
    _props$actionLink = props.actionLink,
    actionLink = _props$actionLink === void 0 ? '' : _props$actionLink,
    actionCallback = props.actionCallback,
    actionRef = props.actionRef,
    actionId = props.actionId,
    titleElement = props.titleElement,
    titleText = props.titleText;
  var TitleElement = titleElement || 'strong';
  var buttonEvents = {
    onClick: actionCallback
  };
  var classes = classnames_default()("able-MessageSection--".concat(variant).concat(actionText ? '--Interactive' : ''), className || undefined);
  var screenReaderContent = variant === 'Information' ? 'Important information' : variant;
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("div", {
    className: classes,
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)(Icon["default"], {
      icon: variant === 'Information' ? 'Info' : variant,
      screenReaderContent: screenReaderContent,
      developmentUrl: developmentUrl,
      size: "24"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("div", {
      children: [titleText ? /*#__PURE__*/(0,jsx_runtime_.jsx)(TitleElement, {
        children: titleText
      }) : null, /*#__PURE__*/(0,jsx_runtime_.jsx)("p", {
        children: description
      }), actionText ? /*#__PURE__*/(0,jsx_runtime_.jsx)(ActionButton["default"], {
        variant: "LowEmphasis",
        label: actionText,
        element: actionElement,
        href: actionLink,
        events: buttonEvents,
        includeAbleClassnames: false,
        id: actionId,
        elementRef: actionRef
      }) : null]
    })]
  });
}
MessageSection.displayName = 'MessageSection';
/* harmony default export */ const MessageSection_MessageSection = (MessageSection);
// EXTERNAL MODULE: ./src/MessageSection/MessageSection.scss
var src_MessageSection_MessageSection = __webpack_require__(4875);
;// CONCATENATED MODULE: ./src/MessageSection/index.ts


/* harmony default export */ const src_MessageSection = (MessageSection_MessageSection);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});